import { useTranslation } from 'react-i18next';
import { resources } from '../../../../resources/resources';

interface PasswordAndMultifactorTabNavProps {
  activeTab: PasswordAndMultifactorTabs;
  onTabChange: (tab: PasswordAndMultifactorTabs) => void;
}

export enum PasswordAndMultifactorTabs {
  Password = 'password',
  Multifactor = 'multifactor',
}

export const PasswordAndMultifactorTabNav = (
  props: PasswordAndMultifactorTabNavProps,
) => {
  const { activeTab, onTabChange } = props;
  const { t: translate } = useTranslation();
  return (
    <ul className="acc-tabs">
      <li
        className={
          activeTab === PasswordAndMultifactorTabs.Password
            ? 'acc-tab-active'
            : undefined
        }
        onClick={() => onTabChange(PasswordAndMultifactorTabs.Password)}
      >
        {translate(resources.changePassword.tabTitle.changePassword)}
      </li>
      <li
        className={
          activeTab === PasswordAndMultifactorTabs.Multifactor
            ? 'acc-tab-active'
            : undefined
        }
        onClick={() => onTabChange(PasswordAndMultifactorTabs.Multifactor)}
      >
        {translate(resources.changePassword.tabTitle.multifactorInfo)}
      </li>
    </ul>
  );
};
